import { ColDef } from '@ag-grid-community/core'
import { makeGetter, NfColumnTypes, NfGridOptions } from '@northfork/ag-grid'
import { NgGridComponents } from '@northfork/ag-grid-angular'
import { heliosDefaultColWidth } from './default'

export const HsDateColDef: ColDef = {
  ...(NfGridOptions.columnTypes?.[NfColumnTypes.Date] ?? {}),
  filter: NgGridComponents.dateFilter,
  // Used to fix issue where ag grid date columns are resizable smaller than 140px
  minWidth: undefined,
  resizable: true,
  width: heliosDefaultColWidth.DateCol,
  filterParams: undefined,
  filterValueGetter: makeGetter((value: string) => value),
}
